/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import cookies from 'react-cookies';
import {
  DetailsContent,
  BodyDetailsClient,
  Title,
  BodyDetails,
  LeftDetails,
  RightDetails,
  DetailsClient,
  TitleDetailsClient,
} from './styles';
import Skeleton from '../../../styles/skeleton';
import api from '../../../services/api';
import BackButton from '../../BackButton';

interface iDTO {
  id?: string | undefined;
}
export interface dataServerDTO {
  created_at: string;
  creditor: dataTableInfo;
  debtor: dataTableInfo;
  due_date: string;
  total_value: string;
  id: number;
  percentage_value: string;
  status: string;
  updated_at?: string;
  proposal_type: 'registrar' | 'split';
}

export interface dataTableInfo {
  affiliation_key: string;
  document: string;
  fantasy_name: string;
  id: number;
  legal_name: string;
  on_registry: boolean;
  stone_code: string;
}

const Details = () => {
  const { id: idFilter } = useParams<iDTO>();
  const [dataContract, setDataContract] = useState<dataServerDTO>();
  const [fantasyName, setFantasyName] = useState<string>();
  const [socialName, setSocialName] = useState<string>();
  const [document, setDocument] = useState<string>();
  const [stoneCode, setStone] = useState<string>();
  const [isOnRegistrar, setIsOnRegistrar] = useState<boolean>(false);

  useEffect(() => {
    if (dataContract && cookies.load('external_tags')) {
      if (cookies.load('external_tags').gps_recebedor) {
        setSocialName(dataContract.debtor.legal_name);
        setFantasyName(dataContract.debtor.fantasy_name);
        setDocument(dataContract.debtor.document);
        setStone(dataContract.debtor.stone_code);
      } else if (cookies.load('external_tags').gps_originador) {
        setSocialName(dataContract.creditor.legal_name);
        setFantasyName(dataContract.creditor.fantasy_name);
        setDocument(dataContract.creditor.document);
        setStone(dataContract.creditor.stone_code);
      }
      setIsOnRegistrar(dataContract.proposal_type === 'registrar')
    }
  }, [dataContract]);

  useEffect(() => {
    async function findId() {
      const idProposal = idFilter;
      if (idProposal) {
        const response = await api.get(
          `/v0/gps/merchants/${cookies.load(
            'external_stone_codes',
          )}/proposals/${idProposal}`,
          {
            headers: {
              Authorization: `Bearer ${cookies.load('external_token')}`,
            },
          },
        );
        // eslint-disable-next-line consistent-return
        if ((idFilter && response.status === 200) || response.status === 204) {
          if (cookies.load('external_tags'))
            if (cookies.load('external_tags').gps_recebedor) {
              setDataContract(response.data);
            } else if (cookies.load('external_tags').gps_originador) {
              setDataContract(response.data);
            }
        } else {
          alert(response.statusText);
        }
      }
    }
    findId();
  }, [idFilter]);
  function statusText(status: string | undefined) {
    switch (status) {
      case 'AP':
        return 'Aprovada';
      case 'RE':
        return 'Rejeitada';
      case 'PE':
        return 'Pendente';
      case 'ED':
        return 'Edição';
      case 'DI':
        return 'Finalizada';
      default:
        return 'Carregando';
    }
  }
  function statusColor(status: string | undefined) {
    switch (status) {
      case 'AP':
        return '#0DB14B';
      case 'RE':
        return '#E01342';
      case 'PE':
        return '#FDCE08';
      case 'ED':
        return '#FDCE08';
      case 'DI':
        return '#747474';
      default:
        return '#DCDCDC';
    }
  }
  return (
    <DetailsContent>
      <Title>
        <span
          style={{
            color: '#0DB14B',
            fontFamily: 'Roboto',
            fontWeight: 500,
          }}
        >
          {`Proposta #${`00000${idFilter}`.slice(-5)}`}
        </span>
        <div
          id="btnBack"
          style={{
            display: 'flex',
            flex: 1,
            height: 1,
            background: '#0DB14B',
            marginRight: 20,
            marginLeft: 20,
          }}
        />
        <BackButton adress="/" />
      </Title>
      <BodyDetails>
        <LeftDetails>
          <DetailsClient>
            <TitleDetailsClient>
              {cookies.load('external_tags').gps_recebedor
                ? 'Detalhes do Lojista'
                : cookies.load('external_tags').gps_originador
                ? 'Detalhes do Fornecedor'
                : ''}
            </TitleDetailsClient>
            <BodyDetailsClient>
              <span>Nome Fantasia</span>
              {fantasyName ? (
                <label>{fantasyName}</label>
              ) : (
                <Skeleton
                  style={{
                    width: 200,
                    height: 30,
                    borderRadius: 4,
                    marginBottom: 20,
                  }}
                />
              )}
              <span>Nome Social</span>
              {socialName ? (
                <label>{socialName}</label>
              ) : (
                <Skeleton
                  style={{
                    width: 180,
                    height: 30,
                    borderRadius: 4,
                    marginBottom: 20,
                  }}
                />
              )}
              <span>CPF/CNPJ</span>
              {document ? (
                <label>{document}</label>
              ) : (
                <Skeleton
                  style={{
                    width: 220,
                    height: 30,
                    borderRadius: 4,
                    marginBottom: 20,
                  }}
                />
              )}
              {!isOnRegistrar && (
                <>
                  <span>Stone Code</span>
                  {stoneCode ? (
                    <label>{stoneCode}</label>
                  ) : (
                    <Skeleton
                      style={{
                        width: 170,
                        height: 30,
                        borderRadius: 4,
                        marginBottom: 20,
                      }}
                    />
                  )}
                </>
              )}
              <span>Status</span>
              {stoneCode ? (
                <label>
                  {statusText(dataContract?.status)}
                  <div
                    style={{
                      width: 10,
                      height: 10,
                      borderRadius: 10,
                      marginLeft: 5,
                      background: statusColor(dataContract?.status),
                    }}
                  />
                </label>
              ) : (
                <Skeleton
                  style={{
                    width: 150,
                    height: 30,
                    borderRadius: 4,
                    marginBottom: 20,
                  }}
                />
              )}
            </BodyDetailsClient>
          </DetailsClient>
        </LeftDetails>
        <RightDetails>
          <TitleDetailsClient>Detalhes da Proposta</TitleDetailsClient>

          <BodyDetailsClient>
            <Title>
              <div>
                <span>Valor Limite(opcional)</span>
                {stoneCode ? (
                  <label>{`R$ ${dataContract?.total_value || '00,00'}`}</label>
                ) : (
                  <Skeleton
                    style={{
                      width: 106,
                      height: 30,
                      borderRadius: 4,
                      marginBottom: 20,
                    }}
                  />
                )}
              </div>
              <div>
                <span>Data limite </span>
                {stoneCode ? (
                  <label>
                    {`${dataContract?.due_date.substring(8, 10) || '00'}/${
                      dataContract?.due_date.substring(5, 7) || '00'
                    }/${dataContract?.due_date.substring(0, 4) || '0000'}`}
                  </label>
                ) : (
                  <Skeleton
                    style={{
                      width: 106,
                      height: 30,
                      borderRadius: 4,
                      marginBottom: 20,
                    }}
                  />
                )}
              </div>
            </Title>
            <Title>
              <h4>Direcionamento</h4>
              <h4>Valor / Porcentagem</h4>
            </Title>
            <Title>
              <div>
                <h4>
                  <span>Todos os Direcionamentos</span>
                </h4>
                <h4>
                  <span>
                    Este direcionamento será atribuído para todos os arranjos
                    (bandeiras e modalidades).
                  </span>
                </h4>
              </div>
              {stoneCode ? (
                <label>{`${dataContract?.percentage_value}%`}</label>
              ) : (
                <Skeleton
                  style={{
                    width: 70,
                    height: 30,
                    borderRadius: 4,
                    marginBottom: 20,
                  }}
                />
              )}
            </Title>
          </BodyDetailsClient>
        </RightDetails>
      </BodyDetails>
    </DetailsContent>
  );
};
export default Details;
